import React, { Fragment, useEffect, useState } from 'react'
import { StandardPage } from '../../components/_EOS/StandardPage'
import { GenericTable } from '../../components/_EOS/Table'
import { TypePriority } from '../../interfaces'
import { useModal } from '../../hooks/useModal'
import { useApi } from '../../hooks/useApi'
import { ApiResponse } from '../../typings/ApiResponse'
import { usePagination } from '../../hooks/usePagination'
import {
  createTypePriority,
  getTypePriority,
  putTypePriority
} from './config/api'
import { Status } from '../../hooks/useFetchState'
import { Modal } from '../../components/_EOS/Modal'
import { TypePriorityForm } from './forms'
import { FilterComponent, Filter } from '../../components/_WMS/FilterComponent'
import { filterOptions } from './config/filterOptions'
import { priorityTableHeaderConfigs } from './config/config'
import { useTypesPriority } from '../../hooks/useTypesPriority'

interface TypePriorityPageProps {}

export const TypePriorityPage: React.FC<TypePriorityPageProps> = () => {
  const [selectedFilters, setSelectedFilters] = useState<Filter[]>([])

  const editModal = useModal<TypePriority>('Editar Prioridad', false, 'xs')

  const createModal = useModal('Crear Prioridad')

  const { state, callApi } = useApi<ApiResponse<TypePriority>>()

  const pagination = usePagination(5)

  const requestGetTypePriority = (page: number, pageSize: number, filters: Filter[] = selectedFilters) => {
    const nameFilter = filters.find(f => f.key === 'name')?.value || ''
    callApi(getTypePriority(page, pageSize, nameFilter))
  }

  const requestPutTypePriority = (dto: TypePriority) => {
    callApi(putTypePriority(dto))
  }

  const requestPostTypePriority = (dto: TypePriority) => {
    callApi(createTypePriority(dto))
  }

  const handlePaginationChange = (page: number, pageSize: number) => {
    if (pageSize === pagination.pageSize) {
      requestGetTypePriority(page, pageSize)
      pagination.setPagination(page, pageSize)
    } else {
      requestGetTypePriority(0, pageSize)
      pagination.setPagination(0, pageSize)
    }
  }

  const {
    getTypesPriority,
    typesPriorityState: { typesPriority }
  } = useTypesPriority()

  useEffect(() => {
    if (!typesPriority || typesPriority?.length <= 0) {
      getTypesPriority()
    }
  }, [])

  useEffect(() => {
    requestGetTypePriority(pagination.page, pagination.pageSize)
  }, [])

  return (
    <Fragment>
      <StandardPage
        pageTitle=''
      >
        <FilterComponent
          options={filterOptions}
          onSearchClick={(filters) => {
            setSelectedFilters(filters)
            requestGetTypePriority(0, pagination.pageSize, filters)
          }}
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
          includeAddButton={true}
          onAddButtonClick={() => createModal.openModal('md')}
          addButtonTitle='Crear'
          createButtonTooltip='Crear nueva prioridad'
          includeSearchOnClean={true}
        />

        <GenericTable<TypePriority>
          headersConfig={priorityTableHeaderConfigs}
          IDKey={'typePriorityId'}
          data={state.data?.items}
          actions={{
            onEdit: (_id, row) => editModal.openModal('md', row)
          }}
          pagination={{
            totalItem: state.data?.totalItems || 0,
            page: pagination.page,
            pageSize: pagination.pageSize
          }}
          onPaginationChange={handlePaginationChange}
          isLoading={state.status === Status.Loading}
        />
      </StandardPage>

      <Modal
        open={editModal.isOpen}
        maxWidth={editModal.size}
        title={editModal.title}
        onClose={editModal.closeModal}
      >
        <TypePriorityForm
          initialValues={editModal.extendedProps!}
          onSubmit={async (vals) => {
            requestPutTypePriority(vals)
          }}
          onCancel={editModal.closeModal}
        />
      </Modal>

      <Modal
        open={createModal.isOpen}
        maxWidth={createModal.size}
        title={createModal.title}
      >
        <TypePriorityForm
          initialValues={{ typePriorityId: 0, name: '', value: 0 }}
          onSubmit={async (vals) => {
            requestPostTypePriority(vals)
          }}
          onCancel={createModal.closeModal}
        />
      </Modal>
    </Fragment>
  )
}
